export function pxToRem(px: number): string {
    const base = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return `${px / base}rem`;
}
